import { render, staticRenderFns } from "./ApprovedTestimonialsListView.vue?vue&type=template&id=93290656&scoped=true&"
import script from "./ApprovedTestimonialsListView.vue?vue&type=script&lang=js&"
export * from "./ApprovedTestimonialsListView.vue?vue&type=script&lang=js&"
import style0 from "./ApprovedTestimonialsListView.vue?vue&type=style&index=0&id=93290656&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93290656",
  null
  
)

export default component.exports